import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MembershipRenewalInterstitialService {
  private readonly STORAGE_KEY = 'membership_renewal_interstitial_seen';

  hasSeenInterstitial(): boolean {
    return localStorage.getItem(this.STORAGE_KEY) === 'true';
  }

  markInterstitialAsSeen(): void {
    localStorage.setItem(this.STORAGE_KEY, 'true');
  }

  resetInterstitialStatus(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
